<section class="ui-flow-diagram" [style.min-height.px]="canvasHeight()">
  @if (title()) {
    <header class="ui-flow-diagram__title">{{ title() }}</header>
  }

  <div
    class="ui-flow-diagram__canvas"
    [style.width.px]="canvasWidth()"
    [style.height.px]="canvasHeight()"
  >
    <svg
      class="ui-flow-diagram__edges"
      [attr.viewBox]="'0 0 ' + canvasWidth() + ' ' + canvasHeight()"
      [attr.width]="canvasWidth()"
      [attr.height]="canvasHeight()"
    >
      @for (edge of renderedEdges(); track trackEdge($index, edge)) {
        <path
          class="ui-flow-diagram__edge"
          [class.ui-flow-diagram__edge--dashed]="edge.dashed"
          [attr.d]="edge.path"
          [attr.marker-end]="'url(#' + arrowMarkerId + ')'"
        />
        @if (edge.showMeta) {
          <foreignObject
            [attr.x]="edge.labelX - 80"
            [attr.y]="edge.labelY - 20"
            width="160"
            height="40"
            class="ui-flow-diagram__meta-slot"
          >
            <div xmlns="http://www.w3.org/1999/xhtml" class="ui-flow-diagram__edge-meta">
              <span class="ui-flow-diagram__edge-chip">
                <ui-flow-marker
                  [tone]="edge.marker ?? 'neutral'"
                  [variant]="edge.markerVariant"
                  [tooltipText]="edge.label ?? null"
                />
              </span>
            </div>
          </foreignObject>
        }
      }
      <defs>
        <marker
          [attr.id]="arrowMarkerId"
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="5"
          markerHeight="5"
          orient="auto-start-reverse"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#94a3b8" />
        </marker>
      </defs>
    </svg>

    <div
      class="ui-flow-diagram__nodes"
      [style.grid-template-columns]="layout().columnTemplate"
      [style.grid-template-rows]="layout().rowTemplate"
    >
      @for (node of nodes(); track trackNode($index, node)) {
        <div
          class="ui-flow-diagram__cell"
          [class.ui-flow-diagram__cell--interactive]="node.interactive"
          [style.grid-column]="gridTrack(node.col)"
          [style.grid-row]="gridTrack(node.row)"
          [attr.role]="node.interactive ? 'button' : null"
          [attr.tabindex]="node.interactive ? 0 : null"
          (click)="onNodeClick(node)"
          (keydown)="onNodeKeydown($event, node)"
        >
          @switch (node.type) {
            @case ('process') {
              <ui-flow-process-node [label]="node.label" [caption]="node.caption ?? null" />
            }
            @case ('terminator') {
              <ui-flow-terminator-node [label]="node.label" />
            }
            @case ('document') {
              <ui-flow-document-node [label]="node.label" [caption]="node.caption ?? null" />
            }
            @case ('decision') {
              <ui-flow-decision-node [label]="node.label" />
            }
            @case ('connector') {
              <ui-flow-connector-node [label]="node.label" />
            }
            @case ('off-page') {
              <ui-flow-off-page-node [label]="node.label" />
            }
            @case ('io') {
              <ui-flow-io-node [label]="node.label" [caption]="node.caption ?? null" />
            }
            @case ('note') {
              <ui-flow-note-node [label]="node.label" />
            }
          }
        </div>
      }
    </div>
  </div>
</section>
